import Loading from '@/components/widget/Loading';
export default {
  name: 'Breakdown',
  components: {
    Loading
  },
  props: {
    subscription: {
      type: Object,
      default() {
        return null;
      }
    },
    discount: {
      type: Object,
      default() {
        return null;
      }
    },
    loading: {
      type: Boolean,
      default() {
        return false;
      }
    }
  }
};